<template>
  <v-dialog v-model="dialog" @input="v => v || closeDialog()" max-width="688px">
    <v-card class="d-flex justify-content-center">
      <!-- <v-card-title>{{ dialogTitle }}</v-card-title> -->
      <!-- <v-card-text>
        <div class="text-center py-10">
          <h3>{{ dialogTitle }}</h3>
          <p class="my-3">{{ "lng_box_detail_txt" | translate }}</p>
        </div>
      </v-card-text> -->
      <v-card-text v-if="usersData && usersData.id" class="content-modl">
        <v-img
          @click="closeDialog"
          class="cancel-image"
          src="../../assets/icons/cancel.png"
          height="15px"
          width="15px"
        />
        <div class="text-center py-10">
          <h3>{{ dialogTitle }}</h3>
        </div>
        <p v-if="usersData.systems && usersData.systems.length">
          <strong>{{ "lng_system_state_txt" | translate }}:</strong>
          {{chooseMapPin(usersData.systems[0].sysstate)}}
        </p>
        <p>
          <strong>{{ "lng_th_name_txt" | translate }}:</strong>
          {{usersData.user.firstname}} {{usersData.user.lastname}}
        </p>
        <p>
          <strong>{{ "lng_th_email_txt" | translate }}:</strong>
          {{usersData.user.email}}
        </p>
        <p>
          <strong>{{ "lng_th_address" | translate }}:</strong>
          {{usersData.user | formatAddress}}
        </p>
        
        <p style="text-align: center;">
          <v-btn class="link-button" small color="primary" dark @click="goToSystem">
            {{ "lng_goTo_system" | translate }}</v-btn></p>

        <div style="overflow-x: auto;">
                
          <table
            class="table table-bordered table-striped my-4"
            v-if="usersData.systems && usersData.systems.length"
          >
            <thead>
              <tr>
                <th>#</th>
                <th scope="col">{{ "lng_th_systemId" | translate }}</th>
                <th scope="col">{{ "lng_th_address" | translate }}</th>
                <th scope="col">{{ "lng_th_alarm_email" | translate }}</th>
                <th scope="col">{{ "lng_th_alarm_phone" | translate }}</th>
                <th scope="col">{{ "lng_th_mac_number_txt" | translate }}</th>
              </tr>
            </thead>
            <tbody v-for="(item, index) in usersData.systems" :key="item+index">
              <tr >

                <td data-toggle="collapse" data-target="#collapsedRow1" class="accordion-toggle collapsed expand-button"></td>
                <th scope="row">{{ item.id }}</th>
                <td>
                  {{item | formatAddress}}
                </td>
                <td>{{ item.alarmemail }}</td>
                <td>{{ item.alarmsms }}</td>
                <td>{{ item.mecnumber }}</td>
              
                <tr>
                  <td colspan="12" class="hiddenRow">
                    <div class="accordion-body collapse container-fluid" id="collapsedRow1">
                      <table class="table table-striped table-bordered">
                        <thead>
                          <tr>
                            <th>{{ "lng_th_boxType" | translate }}</th>
                            <th>{{ "lng_th_boxId" | translate }}</th>
                            <th>{{ "lng_th_boxPass" | translate }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{{ "lng_sewer_text" | translate }}</td>
                            <td>{{ item.devices[0].id }}</td>
                            <td>{{ item.devices[0].pincode }}</td>
                          </tr>
                          <tr>
                            <td>{{ "lng_house_text" | translate }}</td>
                            <td>{{ item.devices[1].id }}</td>
                            <td>{{ item.devices[1].pincode }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
            </tbody>
          </table>
                
        </div>
      </v-card-text>

      <v-card-text v-else class="content-modl">
        <v-img
          @click="closeDialog"
          class="cancel-image"
          src="../../assets/icons/cancel.png"
          height="15px"
          width="15px"
        />
        <div class="text-center py-10">
          <h3>{{ dialogTitle }}</h3>
          <v-progress-circular
            color="#0b7894"
            indeterminate
          ></v-progress-circular>
        </div>
      </v-card-text>  
    </v-card>
  </v-dialog>
</template>

<script>
import { countries, sewerTypeValues } from "../../common/Constant";
import GlobalService from "../../services/global-service";
import router from "../../router";
import { translateFunc } from '../../common/Filters';

export default {
  name: "UserInfoModal",
  data() {
    return {
      dialog: false,
      usersData: undefined,
      userTokenResponse: undefined
    };
  },
  props: {
    openDialog: {
      type: Boolean,
      default: false
    },
    closeDialog: {
      type: Function,
      default: undefined
    },
    dialogTitle: {
      type: String,
      default: "Dialog"
    },
    systemData: {
      type: Object,
      default: () => {}
    },
    dealerToken: {
      type: String,
      default: ""
    }
  },
  watch: {
    openDialog: function(newVal) {
      this.dialog = newVal;
      if(newVal){
        this.usersData = undefined;
        this.getUserTokenFromDealer(this.dealerToken);
      }
    }
  },
  mounted() {},
  methods: {
    async getUserTokenFromDealer(token) {
      this.userTokenResponse = await GlobalService.getUserToken(token, this.systemData.userid);
      if (this.userTokenResponse.status === 0 ) {
        await this.fetchUserInfo(this.userTokenResponse.token)
      }
    },
    async fetchUserInfo(token) {
      this.usersData = await GlobalService.getUserInfo(token);
    },
    goToSystem(){
      sessionStorage.setItem("userToken", this.userTokenResponse.token);
      router.push("/");
    },
    chooseMapPin(status) {
      if (status === "0") {
        return translateFunc("lng_marker_green");
      } else if (status === "1") {
        return translateFunc("lng_marker_red");
      } else {
        return translateFunc("lng_marker_grey");
      }
    },
  }
};
</script>
<style scoped>
.fields-group {
  position: relative;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 15px 10px 0px 10px;
}
.group-title {
  background-color: rgb(11, 120, 148, 0.7);
  color: #fff;
  position: absolute;
  top: -10px;
  padding: 0 10px;
  border-radius: 50px;
}
.theme--light.v-card > .v-card__text {
  color: #000;
  width: 95%;
}
.cancel-image {
  position: absolute;
  top: 1rem;
  right: 1rem;
}
.v-dialog > .v-card {
  background-image: linear-gradient(to top, #8aa8ad, transparent);
}
.v-overlay.v-overlay--active.theme--dark {
  z-index: 99991 !important;
}
.v-dialog__content.v-dialog__content--active {
  z-index: 99992 !important;
}
</style>
